// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__CL5Vi","top":"styles_top__1CfWj"};